import axios from 'axios'
import { TEST } from './reducers'
import { getAuthToken } from 'utils'

/**
 * Get test by ID action
 * @route `test/:id`
 * @param {string|number} id Test ID
 * @param {Function} callback Callback function (response/errorMessage, error)
 */
export const getTestById = (id, callback) => {
  return async (dispatch) => {
    dispatch({ type: TEST.LOADING })
    try {
      const res = await axios({
        method: 'GET',
        url: `/test/${id}`,
        headers: {
          Authorization: getAuthToken()
        }
      })
      if (callback) callback(res.data, false)
      dispatch({ type: TEST.GET_TEST_SUCCESS, payload: res.data })
    } catch (err) {
      console.log(err)
      dispatch({
        type: TEST.ERROR,
        payload: err?.response?.data?.message ?? 'Failed to fetch test'
      })
      if (callback)
        callback(err?.response?.data?.message ?? 'Failed to fetch test', true)
    }
  }
}

/**
 * Clear test data action
 */
export const clearTestData = () => ({
  type: TEST.CLEAR
})

// Result actions
export const SET_RESULT_DATA = 'SET_RESULT_DATA';
export const CLEAR_RESULT_DATA = 'CLEAR_RESULT_DATA';

export const setResultData = (data) => ({
  type: SET_RESULT_DATA,
  payload: data
});

export const clearResultData = () => ({
  type: CLEAR_RESULT_DATA
}); 